import { HIDE_CLUSTER_NODE_SUCCESS,HIDE_CLUSTER_NODE_FAILURE } from "../types/clusterNodeTypes";


interface HideClusterNodeInitialState{
    data:[]
}

const initialState: HideClusterNodeInitialState = {
data:[],
};

export function hideClusterReducer(state = initialState, action: any) {
  switch (action.type) {
    case HIDE_CLUSTER_NODE_SUCCESS:
      return {
        ...state,
        data : action.payload
      };

      case HIDE_CLUSTER_NODE_FAILURE:
        return{
            ...state,
            data:[]
        }
    default:
      return state;
  }
}